<template>
    <el-container>
        <el-header style="height: auto;padding: 0">
            <div style="display: flex">
                <div style="display: flex;align-items: center;flex: 1;justify-content: center">考生：{{users.userName}}</div>
                <div style="display: flex;align-items: center;flex: 1;justify-content: center">分数：{{users.score}}</div>
                <div style="display: flex;align-items: center;flex: 1;justify-content: center">是否批改：{{users.isCorrected === 1 ? '是' : '否'}}</div>
            </div>
        </el-header>
        <el-main>
            <div class="box-question" v-for="(item1,index1) in eduExerciseExam" v-if="eduExerciseExam.length > 0">
                <div>
                    <div class="el-row">
                        <div class="el-col el-col-18">
                            <div class="questionbody">
                                <div class="questionNo">{{item1.seq}}.
                                    <p v-html="item1.exercise.exerciseName">

                                    </p>
                                </div>
                            </div>
                            <div v-if="item1.exercise.exerciseType == 1 || item1.exercise.exerciseType == 2">
                                <template v-for="(item2,index2) in item1.exercise.choices">
                                    <span :class="item2.isAnswer === 1 ? 'active' : ''">{{item2.option}}:{{item2.optionContent}}</span>
                                    <br>
                                </template>
                            </div>
                            <div v-if="item1.exercise.exerciseType == 3">
                                <span :class="item1.exercise.judge.judge === 1 ? 'active' : ''">A:正确</span>
                                <br>
                                <span :class="item1.exercise.judge.judge === 0 ? 'active' : ''">B:错误</span>
                            </div>
                            <div v-if="item1.exercise.exerciseType == 4">
                                <template v-for="(item2,index2) in item1.exercise.fillblanks">
                                    <span class="" >{{item2.fillSeq}}:{{item2.fillContent}}</span>
                                    <br>
                                </template>
                            </div>
                            <div class="questionNo">我的答案：
                                <p v-html="item1.myAnswer"></p>
                            </div>
                            <template v-if="item1.exercise.exerciseType == 1 || item1.exercise.exerciseType == 2 || item1.exercise.exerciseType == 3">
                                <div class="questionNo">正确答案：
                                    <p v-if="item1.exercise.exerciseType == 1 || item1.exercise.exerciseType == 2">{{item1.exercise.answer}}</p>
                                    <p v-if="item1.exercise.exerciseType == 3">{{item1.exercise.judge.judge === 1 ? '正确' : '错误'}}</p>
                                </div>
                                <!--                                <p v-if="item.exerciseType == 5">{{item1.exercise.reply.replyContent}}</p>-->
                            </template>
                            <template v-if="item1.exercise.exerciseType == 5">
                                <div class="questionNo">正确答案：
                                    <p>{{item1.exercise.reply.replyContent}}</p>
                                </div>
                                <!--                                <p v-if="item.exerciseType == 5">{{item1.exercise.reply.replyContent}}</p>-->
                            </template>
                            <div class="questionNo">解析：<p v-html="item1.exercise.analysis"></p></div>
                        </div>
<!--                        <div class="edit-btn el-col el-col-6" style="text-align: right;">-->
<!--                            <div class="edit-icon">-->
<!--                                <a class="el-link el-link&#45;&#45;primary" style="font-size: 18px; margin-left: 5px;">-->
<!--                                    <span class="el-link&#45;&#45;inner" @click="updateRows('up',index,index1)"><i class="el-icon-top"></i></span>-->
<!--                                </a>-->
<!--                                <a class="el-link el-link&#45;&#45;primary" style="font-size: 18px; margin-left: 5px;">-->
<!--                                    <span class="el-link&#45;&#45;inner" @click="updateRows('down',index,index1)"><i class="el-icon-bottom"></i></span>-->
<!--                                </a>-->
<!--                                <a class="el-link el-link&#45;&#45;primary" style="font-size: 18px; margin-left: 5px;">-->
<!--                                    <span class="el-link&#45;&#45;inner" @click="updateRows('delete',index,index1)"><i class="el-icon-delete"></i></span>-->
<!--                                </a>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                    <div class="el-divider el-divider--horizontal"></div>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import { get } from '@/utils/request';

export default {
    components: { GridSelectU },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            eduExerciseExamRecord: {
                id: '', //
                userId: '', //用户
                examId: '', //考试
                paperType: '',
                exerciseId: '', //习题
                exerciseJson: '', //题目JSON数据（提交试卷时备份的）
                myAnswer: '', //我的答案
                rightAnswer: '', //正确答案
                exerciseAnalysis: '', //题目解析（提交试卷时备份的）
                score: '', //得分
                isCorrected: '', //已批改
            },
            users:{
                userName: '',
                score: '', //得分
                isCorrected: '', //已批改
            },
            eduExerciseExam: []
        };
    },
    methods: {
        getValueUser(val){
            this.eduExerciseExam.isCorrected = val
        },
        init(item){
            this.users.userName = item.user.userName;
            this.users.score = item.score;
            this.users.isCorrected = item.isCorrected;
            this.eduExerciseExamRecord.userId = item.userId;
            this.eduExerciseExamRecord.paperType = item.examType;
            console.log(item)
            this.getEduExerciseExamRecordList();
        },
        getEduExerciseExamRecordList(){
            get(`/edu/exerciseexamrecord/findAll`,{  ...this.eduExerciseExamRecord }).then((res) => {
                if (res.success) {
                    this.eduExerciseExam = res.list;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        }
    }
};
</script>


<style scoped lang="scss">
.box-question-group {
    border: 1px solid #ebeef5;
    margin-bottom: 10px;
}
.box-question-group h4 {
    margin: 0;
    background: #f5f7fa;
    padding: 10px;
}
.box-question-group .now_q_type {
    margin-left: 15px;
    font-size: 18px;
}
.btn {
    margin-left: 15px;
}
.box-question {
    padding: 10px 20px;
}
.el-row {
    margin-bottom: 20px;
}
.questionNo {
    display: flex;
    align-items: center;
}
.questionbody p {
    margin: 2px 0;
}
.questionNo+p {
    display: inline-block;
    width: calc(100% - 50px);
    margin: 0;
}
.box-question .edit-btn .edit-icon {
    margin-top: 15px;
}
.add-question {
    padding: 50px 10px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    text-align: center;
}
.no-question {
    padding: 40px;
    text-align: center;
}
.active {
    color: #409eff;
}
</style>